import { z } from 'zod';

import { schemaConsorsContactAddressPartner } from './contactAddressPartner.schema';
import { schemaConsorsSubscriberMain } from './subscriberMain.schema';

export const schemaConsorsSubscriberPartner = schemaConsorsSubscriberMain.extend({
    contactAddress: schemaConsorsContactAddressPartner,
    rolePlaying: z.literal('PARTNER'),
});

export type SchemaConsorsSubscriberPartner = z.infer<typeof schemaConsorsSubscriberPartner>;
